import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  constructor(private router: Router, private afAuth: AngularFireAuth) { }
  token = JSON.parse(localStorage.getItem('token'))

  ngOnInit(): void {
    console.log('token: ' + this.token)
    this.afAuth.onAuthStateChanged(user => {
      user.getIdTokenResult().then(token => {
        this.token = token.claims.claim;
        if (this.token != 'superadmin' && this.token != 'administrador' && this.token != 'editor') {
          this.router.navigate([''])
        }
      })
    })
  }



}
